import { AppInsightsContext, AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { OidcProvider } from "@axa-fr/react-oidc";
import 'bootstrap/dist/css/bootstrap.css';
import { useEffect } from "react";
import { useLocation } from "react-router";
import './App.css';
import CustomAuthenticatingError from './components/OidcComponents/CustomAuthenticatingError';
import CustomCallback from './components/OidcComponents/CustomCallback';
import CustomLoading from './components/OidcComponents/CustomLoading';
import CustomSessionLost from './components/OidcComponents/CustomSessionLost';
import APIErrorProvider from "./contexts/apiErrorContext";
import { UserPermissionProvider } from './contexts/userPermissionContext ';
import { useClientStyleSheet } from './hooks/useClientStyleSheet';
import { usePageTitle } from './hooks/usePageTitle';
import { Favicon } from "./layouts/Favicon";
import Routers from './routes/routers';
import { IDENTITY_CONFIG } from './utilities/authConstants';
import SessionTimeoutTimer from './utilities/sessionTimeoutTimer';
import { useGoogleTagManager } from "./hooks/useGoogleTagManager";
import { PrimeReactProvider } from 'primereact/api';
import { reactPlugin } from './services/appInsights';
import { OidcRouteSyncWrapper } from './components/OidcRouteSyncWrapper';

const ErrorFallback = () => <h2>An error occurred. Please try again later.</h2>;

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export const App = () => {

    usePageTitle();
    useClientStyleSheet();
    useGoogleTagManager();
    let contents =
        <OidcProvider
            loadingComponent={CustomLoading}
            authenticatingErrorComponent={CustomAuthenticatingError}
            authenticatingComponent={CustomCallback}
            callbackSuccessComponent={CustomCallback}
            serviceWorkerNotSupportedComponent={CustomCallback}
            sessionLostComponent={CustomSessionLost}
            configuration={IDENTITY_CONFIG} >
            <UserPermissionProvider>
                <ScrollToTop />
                <OidcRouteSyncWrapper>
                    <Routers />
                </OidcRouteSyncWrapper>
            </UserPermissionProvider>
            <SessionTimeoutTimer />
        </OidcProvider>

    return (
        <AppInsightsContext.Provider value={reactPlugin}>
            <AppInsightsErrorBoundary onError={ErrorFallback} appInsights={reactPlugin}>
                <div className="App">
                    <Favicon></Favicon>
                    <PrimeReactProvider>
                        <APIErrorProvider>
                            {contents}
                        </APIErrorProvider>
                    </PrimeReactProvider>
                </div>
            </AppInsightsErrorBoundary>
        </AppInsightsContext.Provider>
    );
}
